(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TkbPayment', TkbPayment);

    TkbPayment.$inject = ['$resource', 'DateUtils'];

    function TkbPayment ($resource, DateUtils) {
        var resourceUrl =  'api/tkb-payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getPaymentState': {url: 'api/payment-state/:externalId', method: 'GET'},
            'confirmPayment': {url: 'api/payment-confirm/:externalId', method: 'GET'},
            'recreditPayment': {url: 'api/payment-recredit/:orderId', method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'paymentInfo': {url: 'api/payment-info/:paymentId', method: 'GET'}
        });
    }
})();
